import { useEffect, useState } from "react";

import { useFormUtils } from "@/app/hooks/useFormUtils";
import { RadioGroup } from "@headlessui/react";
import clsx from "clsx";
import FormFieldErrors from "../Reusable/FormFieldErrors";
import { IRadioGroup } from "../interface";

const RadioGroupComponent: React.FC<IRadioGroup> = ({
  groupOptions,
  defaultSelectedId,
  disabled,
  onRadioChange,
  ...props
}) => {
  const { deduceFormFieldErrors } = useFormUtils();

  const [selected, setSelected] = useState<string | null>(null);

  const reducedErrorMessages = deduceFormFieldErrors(props?.errorMessages, props?.fieldError);

  //   const _isValid = isFormFieldValid(reducedErrorMessages);

  useEffect(() => {
    if (defaultSelectedId) {
      setSelected(defaultSelectedId);
    }
  }, [defaultSelectedId]);
  return (
    <div className={clsx(props?.containerClassName)}>
      <RadioGroup
        value={selected}
        onChange={(selOp) => {
          setSelected(selOp);
          if (onRadioChange) {
            onRadioChange(selOp);
          }
        }}
        className={clsx(
          props?.alignment === "vertical"
            ? "flex justify-center items-start flex-col gap-3"
            : "flex justify-start items-center",
          props?.radioGroupClassName,
        )}
      >
        <input hidden {...props.register} />

        {groupOptions.map((option, idx) => {
          return (
            <RadioGroup.Option
              className={clsx(props?.radioOptionClassName)}
              key={`${option.id}:${idx}`}
              value={option.id}
            >
              {({ checked }) => {
                return (
                  <div className="flex justify-start items-center px-2">
                    <input
                      className={clsx(option?.colorClassName ? option.colorClassName : "text-black")}
                      type="radio"
                      checked={checked}
                      disabled={disabled}
                    />
                    <span className="ml-2 text-xs">{option.title}</span>
                  </div>
                );
              }}
            </RadioGroup.Option>
          );
        })}
      </RadioGroup>
      <FormFieldErrors errors={reducedErrorMessages} />
    </div>
  );
};

export default RadioGroupComponent;
